import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { clearOAuthFlowState } from '../_helpers/oauthFlowState.js';
import { BETA_WAITLISTED, clearSessionStorage, waitlistPath } from '../_helpers/betaWaitlist.js';

// The route the backend's Sign in with Apple callback redirects to (its
// `appleCallbackPath`). Apple posts the callback to the backend, which then
// sends the browser here, so the outcome arrives in the URL rather than as a
// JSON answer.
export const APPLE_RETURN_PATH = '/oauth/apple';

/**
 * Handles the beta gate's refusal of an Apple sign-in (ENG-913/ENG-915):
 * `/oauth/apple?error=beta_waitlisted&status=pending|rejected` carries no
 * token, and goes to the waitlist page with the status. Any other arrival
 * renders nothing here, as this path did before it had a route.
 */
function AppleOAuthReturn() {
  const navigate = useNavigate();
  const { search } = useLocation();
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;
    const query = new URLSearchParams(search);
    if (query.get('error') !== BETA_WAITLISTED) return;
    clearOAuthFlowState();
    clearSessionStorage();
    navigate(waitlistPath(query.get('status'), 'apple'), { replace: true });
  }, [navigate, search]);

  return null;
}

export default AppleOAuthReturn;
